import { z } from 'zod';

export const PackageMeta = z
  .object({
    label: z.string().trim().optional(),
    name: z.string().trim().optional(),
    id: z.string().trim().optional(),
    version: z.string().trim().optional(),
    categories: z.array(z.string()).optional(),
    description: z.string().trim().nullable().optional(),
    icon: z.string().trim().nullable().optional(),
    iconType: z.string().trim().nullable().optional(),
    recommendedSteps: z.array(z.string()).nullable().optional(),
    shape: z.string().trim().nullable().optional(),
    tags: z.array(z.string().trim()).nullable().optional(),
  })
  .passthrough()
  .default({});
